import * as React from "react";
import { Field, reduxForm } from "redux-form";
import FormElements from "../../FormElements";

const s = require("./askForCodeForm.scss");
const InputElement = require("react-input-mask");

export interface Props {
    onSubmit: () => void;
    handleSubmit?: () => void;
}

const codeInput = (field: any) => {
    return (
        <InputElement
            className={s.codeInput}
            mask="9 9 9 9"
            maskChar=" "
            type="text"
            {...field.input}
        />
    );
};


class AskForNumber extends React.Component<Props, {}> {
    render() {
        return (
        <form onSubmit={this.props.handleSubmit}>
            <Field
                name="code"
                component={codeInput}
            />
            <FormElements.Buttons.SubmitButton />
        </form>
        );
    }
}

export default reduxForm({
  form: "AskForCodeForm"
})(AskForNumber);



// WEBPACK FOOTER //
// ./src/components/Forms/AskForCode/index.tsx